import app from 'store/slices/app';
import files from 'store/slices/files';
import transfers from 'store/slices/transfers';

export default {
  app,
  files,
  transfers,
};
